import { FC } from "react";
import { Label, Listbox, ListboxButton, Transition } from "@headlessui/react";
import { ChevronDown, Globe } from "lucide-react";

import { useAppDispatch, useAppSelector, changeActiveSite } from "../../store";
import { transitionSimpleLeaveStyles } from "../../ui/layout/Transition/constants";
import {
  LARGE_ICON_SIZE_STYLES,
  MEDIUM_ICON_SIZE_STYLES,
} from "../../ui/styles";
import { ListboxDropdown } from "../../ui/layout/ListboxDropdown";

export const SitesListDropdownAlt: FC<React.PropsWithChildren> = () => {
  const sites = useAppSelector((state) => state.sites.sites);
  const isSitesLoading = useAppSelector(
    (state) => state.sites.status === "loading",
  );
  const selected = useAppSelector((state) => state.site);
  const dispatch = useAppDispatch();

  const getSiteTitle = () => {
    if (isSitesLoading) return "Loading sites";
    if (sites.length === 0) return "No sites available";
    return selected?.domain;
  };

  return (
    <Listbox
      value={selected}
      onChange={(site) => dispatch(changeActiveSite(site))}
    >
      {({ open }) => (
        <div
          className={`relative w-full lg:w-64 ${
            sites.length === 0 ? "cursor-not-allowed" : ""
          }`}
        >
          <ListboxButton
            className={`grid h-12 w-full cursor-pointer grid-cols-[1fr_24px] gap-3 rounded-md bg-stone-100 py-1 pl-3 pr-2 text-left shadow-sm focus:border-stone-500 focus:outline-none focus:ring-1 focus:ring-stone-500 dark:bg-stone-800 sm:grid-cols-[24px_1fr_24px] *:truncate ${
              sites.length === 0 ? "pointer-events-none" : ""
            }`}
          >
            <Globe
              className={`hidden self-center text-stone-500 sm:inline-block ${LARGE_ICON_SIZE_STYLES}`}
            />
            <div className="inline">
              <Label className="block text-xs text-stone-500">Site</Label>
              <span
                className={`text-md block truncate text-stone-900 dark:text-stone-50 ${
                  isSitesLoading ? "animate-pulse" : ""
                }`}
              >
                {getSiteTitle()}
              </span>
            </div>
            <span className="self-center pr-2">
              <ChevronDown
                className={`text-stone-400 ${MEDIUM_ICON_SIZE_STYLES}`}
              />
            </span>
          </ListboxButton>

          <Transition
            show={open && !isSitesLoading}
            as="div"
            {...transitionSimpleLeaveStyles}
          >
            <ListboxDropdown listItems={sites} />
          </Transition>
        </div>
      )}
    </Listbox>
  );
};
